




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { ListSaveActions } from '@/actions/list-save-actions';

import { UserModule, UserStore } from '@/store/modules/user';

import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { MutationPayload } from 'vuex';

@Component({})
export default class ListSaveWidget extends Vue {
  @Prop(ListModel) public list!: ListModel;
  isSaved: boolean = false;

  get classes(): any {
    const classDict: any = {
      save: !this.isSaved,
      saved: this.isSaved
    };
    return classDict;
  }

  checkIsSaved() {
    this.isSaved = UserModule.savedListIds.indexOf(this.list.id) > -1;
  }
  
  created() {
    this.checkIsSaved();

    this.$store.subscribe((mutation: MutationPayload, state: any) => {
      if (mutation.type === UserStore.SET_SAVED_LIST_IDS_MUTATION) {
        this.checkIsSaved();
      }
    });
  }

  get canEditList() {
    return ListModelUtil.canEditList(this.list, UserModule.currentUserId);
  }

  get saveIcon() {
    if (!this.isSaved) {
      return '@/assets/images/icon__sharp-bookmark_border-24px.svg';
    } else {
      return '@/assets/images/icon__sharp-bookmark-24px.svg';
    }
  }

  toggleSaveState() {
    if (!this.isLoggedIn) {
      this.$router.push('/login');
      return;
    }

    const wasSaved = this.isSaved;
    this.isSaved = !this.isSaved;
    if (wasSaved) {
      ListSaveActions.unsaveList({
        listId: this.list.id,
        userId: UserModule.currentUserId
      });
      this.list.numSaves -= 1;
    } else {
      ListSaveActions.saveList({
        listId: this.list.id,
        userId: UserModule.currentUserId
      });
      this.list.numSaves += 1;
    }
  }

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }
}
